import { render, staticRenderFns } from "./item-detail.vue?vue&type=template&id=6fb2d3da&scoped=true"
import script from "./item-detail.vue?vue&type=script&lang=js"
export * from "./item-detail.vue?vue&type=script&lang=js"
import style0 from "./item-detail.vue?vue&type=style&index=0&id=6fb2d3da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb2d3da",
  null
  
)

export default component.exports